import * as React from "react";
import classNames from "classnames";

import * as Assets from "../../assets";
import classes from "./index.module.scss";

interface IProps {
	label?: string;
	onClick?: () => void;
	active?: boolean;
	type?: "default" | "alarms" | "marken" | "marken-alarms" | "marken-download";
	alarmsCount?: number;
	className?: string;
	isLoading?: boolean;
}

export const DeviceInfoButton = (props: IProps): JSX.Element => {
	const countTextStyle = classNames(classes.alarms__countText, props.alarmsCount ? classes.alarms__alarm : classes.alarms__noAlarm);
	const countOuterStyle = classNames(classes.alarms__count_outer, props.alarmsCount ? classes.alarms__count_outer_alarm : classes.alarms__count_outer_noAlarm);
	const icons: Map<string, string> = new Map<string, string>([
		["home", Assets.Sensors.HomeButton],
		["reports", Assets.Reports],
		["rules", Assets.Sensors.Rules],
	]);

	const getIconSrc = (): string => {
		let imgSrc = Assets.ImgBroken;

		if (!!props.label && icons.has(props.label.toLowerCase())) {
			imgSrc = icons.get(props.label.toLowerCase()) as string;
		}

		return imgSrc;
	};

	const onClickHandler = (event: React.MouseEvent<HTMLElement>): void => {
		event.preventDefault();
		if (props.onClick) {
			props.onClick();
		}
	};

	const alarmButton = (): JSX.Element => (
		<div className={classNames(classes.deviceInfoButton__alarms, classes.alarms)}>
			<img className={classes.alarms__img} alt={""} src={Assets.Alarms.YellowAlarmTriangle} />
			<div className={countOuterStyle}>
				<div className={classes.alarms__count_inner}>
					<div className={countTextStyle}>{props.alarmsCount}</div>
				</div>
			</div>
		</div>
	);

	const defaultButton = (): JSX.Element => (
		<div className={classes.deviceInfoButton__column}>
			<div className={classNames(classes.deviceInfoButton__top, classes.top)}>
				<div className={classes.top__row}>
					<img className={classes.top__img} alt={""} src={getIconSrc()} />
					<div className={classes.top__center} />
					<div className={classes.top__img} />
				</div>
			</div>
			<div className={classes.deviceInfoButton__title}>
				{props.label}
			</div>
			<div className={classes.deviceInfoButton__bottom} />
		</div>
	);

	const markenButton = (): JSX.Element => (
		<div className={classNames(classes.deviceInfoButton__column, classes.markenButton)}>
			<img className={classes.markenButton__img} alt={""} src={getIconSrc()} />
			<div className={classes.markenButton__empty}>transparent</div>
			<div className={classes.markenButton__title}>{props.label}</div>
			<div className={classes.markenButton__bottom}>transparent</div>
		</div>
	);

	const markenAlarmsButton = (): JSX.Element => (
		<div className={classNames(classes.deviceInfoButton__column, classes.markenButton, classes.alarms)}>
			<div className={classNames(classes.markenButton__alarms, classes.alarms)}>
				<img className={classes.alarms__img} alt={""} src={Assets.Alarms.YellowAlarmTriangle} />
				<div className={countOuterStyle}>
					<div className={classes.alarms__count_inner}>
						<div className={countTextStyle}>{props.alarmsCount}</div>
					</div>
				</div>
			</div>
			<div className={classes.markenButton__empty}>transparent</div>
			<div className={classes.markenButton__title}>alarms</div>
			<div className={classes.markenButton__bottom}>transparent</div>
		</div>
	);

	const markenDownloadButton = (): JSX.Element => (
		<div className={classNames(classes.deviceInfoButton__column, classes.markenButton)}>
			<div className={classNames(classes.markenButton__download)}>
				{!props.isLoading && (<img className={classes.markenButton__downloadImg} alt={""} src={Assets.DownloadReport} />)}
				{props.isLoading && (<img className={classes.markenButton__loadingImg} alt={""} src={Assets.Loading} />)}
			</div>
		</div>
	);

	return (
		<div className={classNames(classes.deviceInfoButton, props.className, props.active ? classes.deviceInfoButton_active : "")}
			onClick={onClickHandler}>
			{(!props.type || props.type === "default") && defaultButton()}
			{props.type === "alarms" && alarmButton()}
			{props.type === "marken" && markenButton()}
			{props.type === "marken-alarms" && markenAlarmsButton()}
			{props.type === "marken-download" && markenDownloadButton()}
		</div>
	);
};
